<template>
  <div class="ui basic segment">
    <div class="ui container grid">
      <!-- <div class="five wide column"> -->
      <prototype-list @selected="select_prototype" />
      <!-- </div> -->
      <!-- <div class="eleven wide column"> -->
      <prototype-composer :templates="templates" ref="prototype_composer" />
      <!-- </div> -->
    </div>
  </div>
</template>

<script>
import { local_api, stringify } from "@/utils";
import filters from "@/filters";
import PrototypeComposer from "./prototype_composer/Index";
import PrototypeList from "./PrototypeList";

export default {
  name: "PrototypeComposerIndex",
  components: { PrototypeComposer, PrototypeList },
  filters: filters,
  data() {
    return {
      reports_by_prototype: [],
      templates: [],
    };
  },
  methods: {
    select_prototype(item) {
      this.$refs.prototype_composer.load_prototype(item);
    },
  },
  created() {},
  mounted() {
    let vm = this;
    local_api(vm, "post", "/system/do-get-templates")
      .then((templates) => {
        vm.templates = templates;
      })
      .catch((err) => {
        vm.$alertify.error(stringify(err));
      });
  },
};
</script>
